export default "__VITE_ASSET__BJCAtDLU__"